import { useState } from "react";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { toast } from "sonner";
import { SectionTitle } from "@/components/GlassBits";

export default function CustomerProfile() {
  const { user, refreshMe } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    company_name: user?.company_name || "",
    gst_number: user?.gst_number || "",
    address: user?.address || "",
  });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch("/customer/profile", form);
      await refreshMe();
      toast.success("Profile updated");
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <div>
      <SectionTitle eyebrow="Profile" title="Account details" />
      <div className="grid md:grid-cols-3 gap-4">
        <div className="ldc-glass p-6 md:col-span-1">
          <div className="w-16 h-16 rounded-full bg-[#fbce18]/20 flex items-center justify-center text-[#fbce18] font-display text-2xl font-semibold">
            {user?.name?.[0]?.toUpperCase()}
          </div>
          <div className="mt-4 font-display text-lg">{user?.name}</div>
          <div className="text-sm text-white/60">{user?.email}</div>
          <div className="mt-2 ldc-badge ldc-badge-pending inline-block">{user?.role}</div>
        </div>
        <form onSubmit={save} className="ldc-glass p-6 md:col-span-2 space-y-3" data-testid="cprofile-form">
          <F label="Name" v={form.name} on={(v) => setForm({...form, name: v})} testid="cp-name" />
          <F label="Phone" v={form.phone} on={(v) => setForm({...form, phone: v})} testid="cp-phone" />
          <F label="Company" v={form.company_name} on={(v) => setForm({...form, company_name: v})} testid="cp-company" />
          <F label="GSTIN" v={form.gst_number} on={(v) => setForm({...form, gst_number: v})} testid="cp-gst" />
          <label className="block">
            <div className="text-[10px] tracking-[0.24em] uppercase text-white/40 mb-1.5">Address</div>
            <textarea value={form.address} onChange={(e) => setForm({...form, address: e.target.value})} rows={3} className="ldc-input w-full rounded-md px-3 py-2 text-sm" data-testid="cp-address" />
          </label>
          <div className="pt-2">
            <button type="submit" disabled={busy} className="ldc-btn-primary px-6 py-2.5 rounded-md text-sm" data-testid="cp-save">{busy ? "Saving…" : "Save changes"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
function F({ label, v, on, testid }) {
  return (
    <label className="block">
      <div className="text-[10px] tracking-[0.24em] uppercase text-white/40 mb-1.5">{label}</div>
      <input value={v} onChange={(e) => on(e.target.value)} className="ldc-input w-full rounded-md px-3 py-2 text-sm" data-testid={testid} />
    </label>
  );
}
